/* eslint-disable */
import { DeliveryDates } from '../models/delivery.dates.model';

export const mockDates = [
  '2021-06-16T00:00:00',
  '2021-06-17T00:00:00',
  '2021-06-18T00:00:00',
  '2021-09-23T00:00:00',
  '2021-09-24T00:00:00',
  '2021-09-25T00:00:00',
  '2021-09-26T00:00:00',
  '2021-09-30T00:00:00',
  '2021-10-01T00:00:00',
  '2021-10-02T00:00:00',
];

export const mockDeliveryDates: DeliveryDates = {
  delivery_dates: mockDates,
  message: 'OK',
};

export const mockDeliveryDatesEmpty: DeliveryDates = {
  delivery_dates: [],
  message: 'OK',
};
